import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Errore imprevisto";
  if (typeof d === "string") return d;
  return String(d);
}

export default function UserForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) { toast.error("Inserisci la tua email"); return; }
    setBusy(true);
    try {
      const r = await axios.post(`${API}/user-auth/forgot-password`, { email: email.trim() });
      toast.success(r.data?.message || "Richiesta inviata");
      setSent(true);
    } catch (err) {
      toast.error(formatErr(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6" data-testid="user-forgot-password-page">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-lg shadow-sm p-8">
        <p className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold mb-1">Unioncasa · Pannello Associato</p>
        <h1 className="text-2xl font-serif text-slate-900 mb-2">Recupera la password</h1>
        <p className="text-sm text-slate-600 mb-6">
          Inserisci l'email associata al tuo account: ti invieremo un link per reimpostare la password. Il link sarà valido per 15 minuti.
        </p>

        {sent ? (
          <div className="border border-emerald-200 bg-emerald-50 rounded-md p-4 mb-4" data-testid="forgot-password-sent">
            <div className="flex gap-3">
              <CheckCircle2 size={20} className="text-emerald-700 flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-emerald-900">Controlla la tua casella email</p>
                <p className="text-xs text-emerald-800 mt-1">
                  Se l'indirizzo <strong>{email}</strong> è associato a un account, riceverai a breve un'email con il link per reimpostare la password.
                  Ricordati di controllare anche la cartella "Spam" o "Posta indesiderata".
                </p>
              </div>
            </div>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-xs font-medium text-slate-700 mb-1">Email</label>
              <div className="relative">
                <Mail size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                <input type="email" value={email} onChange={e=>setEmail(e.target.value)}
                  className="w-full h-10 pl-9 pr-3 border border-slate-300 rounded-md focus:outline-none focus:border-slate-900 text-sm"
                  data-testid="forgot-email-input" required />
              </div>
            </div>
            <button type="submit" disabled={busy}
              className="w-full h-11 rounded-md bg-slate-900 text-white text-sm font-medium hover:bg-black disabled:opacity-60"
              data-testid="forgot-submit-btn">
              {busy ? "Invio in corso..." : "Invia link di reset"}
            </button>
          </form>
        )}

        <p className="text-xs text-slate-600 mt-6 text-center">
          <Link to="/utente/login" className="inline-flex items-center gap-1 text-slate-900 font-medium hover:underline" data-testid="back-to-login-link">
            <ArrowLeft size={12} /> Torna al login
          </Link>
        </p>
      </div>
    </div>
  );
}
